import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as Actions from '../../actions/actions';

const Logout = function (props) {
  const { authVm: { uid }, logout } = props;

  if (uid !== undefined) {
    logout();
  }

  return <div className="logout">...</div>;
};

export default connect(
  state => ({ ...state.authReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(Logout);




// WEBPACK FOOTER //
// ./src/pages/Logout/index.js